import axios from "axios";
import { Auth } from "aws-amplify";

const axiosClient = axios.create();

// axiosClient.defaults.baseURL = 'https://api.staging.nuvve.dev/';
axiosClient.defaults.baseURL = process.env.REACT_APP_NUVVE_PARTNER_API_URL;

axiosClient.defaults.headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
  Authorization: `Bearer ` + localStorage.getItem("accessToken"),
};

//All request will wait 2 seconds before timeout
axiosClient.defaults.timeout = 2000000;

axiosClient.defaults.withCredentials = false;

const getUserToken = async () => {
  const res = await Auth.currentSession();
  return res.getAccessToken().getJwtToken();
};

axiosClient.interceptors.request.use(
  async (config) => {
    const accessTokenResponse = await getUserToken();

    if (config.headers) {
      config.headers.Authorization = `Bearer ${accessTokenResponse}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export function getRequest(URL) {
  //commented code for mocky api calls
  // return axios.get(`${URL}`).then(response => response);
  return axiosClient.get(`/${URL}`).then((response) => response);
}
export function getRequestWithBlob(URL) {
  //commented code for mocky api calls
  // return axios.get(`${URL}`).then(response => response);
  return axiosClient({
    url: `/${URL}`, //your url
    method: "GET",
    responseType: "blob", // important
  }).then((response) => response);
}
export function getMockyRequest(URL) {
  //commented code for mocky api calls
  return axios.get(`${URL}`).then((response) => response);
}

export function postRequest(URL, payload) {
  return axiosClient.post(`/${URL}`, payload).then((response) => response);
}

export function patchRequest(URL, payload) {
  // return axiosClient.patch(`/${URL}`, payload).then(response => response);
  return axiosClient.patch(`/${URL}`, payload).then((response) => response);
}
export function putRequest(URL, payload) {
  // return axiosClient.patch(`/${URL}`, payload).then(response => response);
  return axiosClient.put(`/${URL}`, payload).then((response) => response);
}
export function deleteRequest(URL) {
  return axiosClient.delete(`/${URL}`).then((response) => response);
}
